var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { "escape-close": "" },
      model: {
        value: _vm.state.loadDepositsData.modal,
        callback: function ($$v) {
          _vm.$set(_vm.state.loadDepositsData, "modal", $$v)
        },
        expression: "state.loadDepositsData.modal",
      },
    },
    [
      _c(
        "w-card",
        { style: _vm.cardStyle },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("import-deposits")) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "", disabled: _vm.isComputing },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c("w-data-table", {
            attrs: {
              items: _vm.items,
              columns: _vm.columns,
              "selected-items": _vm.state.loadDepositsData.selectedDeposits,
              "column-resize-handle": "",
              "use-checkboxes": "",
            },
          }),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban", disabled: _vm.isComputing },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "confirm",
                  attrs: { icon: "check", disabled: _vm.confirmDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }